import React, { useEffect, useState } from 'react'
import api from '../api/api'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router'
import { LoadingModal } from '../Utils/Loader'

export const Programs = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {areaName} = location.state
    const data = {name:areaName}
    const [isLoading, setIsLoading] = useState(false)
    const [programs,setPrograms] = useState([]);

    const programsLength = programs.length
    const gotToMap = (id,name,alias) => {
        navigate('/map',{state:{id:id,name:name,alias:alias}})
    };
    
    useEffect(() => {
        const fetchPrograms = async () => {
            setIsLoading(true)
            try {
                const response = await api.post('/programs', data)
                console.log(response.data)
                setPrograms(response.data)
            } catch (error) {
                console.error('Error fetching programs:', error)
            } finally {
                setIsLoading(false)
            }
        }

        fetchPrograms()
    }, [])

    return (
        <LoadingModal isLoading={isLoading}>
            <div className="flex items-center justify-center w-full h-full text-center">
                <div className={`grid w-full max-w-4xl h-[80%] place-items-center ${
                    programsLength <= 4 
                    ? `flex flex-col items-center justify-center`
                    : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
                }`}>
                    {programs?.map((a) => (
                        <div
                            key={a.id}
                            onClick={() => gotToMap(a.id, a.name, a.alias)}
                            className="flex items-center justify-center w-[200px] h-[100px] bg-white rounded-2xl shadow-2xl transform transition-transform duration-200 hover:scale-110 cursor-pointer"
                        >
                            <span>{a.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </LoadingModal>
    )
}